import script from "./ModalLista.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalLista.vue?vue&type=script&setup=true&lang=ts"

import "./ModalLista.vue?vue&type=style&index=0&id=b7af5c2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7af5c2c"]])

export default __exports__